export default __webpack_public_path__ + "static/testimonials-img-ae245647dee7a66065367d6b5f4edda3.webp";